import React from 'react';
import './Psychotherapie.scss';

/**
 * Page explicative de la psychothérapie (publics concernés, 1er entretien et suivi).
 */
const Psychotherapie = () => {
  return (
    <div className="psychotherapie-page container">
      <header className="page-header">
        <h1>La psychothérapie</h1>
        <p className="subtitle">
          Un espace d'écoute, de réflexion et d'accompagnement pour retrouver un mieux-être.
        </p>
      </header>

      {/* Public concerné */}
      <section className="target-section">
        <h2>La psychothérapie peut être proposée pour :</h2>
        <div className="target-cards">
          <div className="target-card">
            <span>👤</span>
            <p>Des nouveaux patients à partir de 16 ans</p>
          </div>
          <div className="target-card">
            <span>📋</span>
            <p>Les patients ayant réalisé un bilan neuropsychologique à partir de 16 ans</p>
          </div>
        </div>
      </section>

      {/* Explications générales */}
      <section className="intro-card intro-card-first">
        <p>
          Les séances permettent d’aborder un large éventail de problématiques : 
          <strong> mal-être, anxiété, épuisement, trouble dépressif, difficultés relationnelles, gestion émotionnelle, estime de soi</strong>, ou encore <strong>situations de changement</strong>.
        </p>
        <p>
          Chaque suivi est personnalisé et adapté à vos besoins, dans un cadre <strong>bienveillant, confidentiel et sans jugement</strong>.
        </p>
      </section>

      <section className="intro-card intro-card-second">
        <p>
          Je suis également en formation pour devenir psychothérapeute en thérapies comportementales, cognitives et émotionnelles (TCCE).
        </p>
      </section>

      {/* Déroulement des consultations */}
      <section className="consultation-types">
        <div className="consultation-card">
          <div className="card-header">
            <h3>Le premier entretien</h3>
            <span className="duration">Durée : 50 minutes</span>
          </div>
          <p>
            Il est avant tout un temps de rencontre et d’échange. Il nous permet de faire connaissance, 
            de comprendre votre demande et le contexte dans lequel vous venez, d’explorer votre histoire, 
            votre fonctionnement ainsi que vos difficultés actuelles.
          </p>
          <p>
            Ensemble, nous clarifions vos attentes et définissons les objectifs de suivi. 
            Ce premier rendez-vous est également l’occasion de vous présenter le cadre des séances 
            (confidentialité, fréquence, déroulement) afin de construire un accompagnement adapté à votre situation.
          </p>
          <p className="key-point">
            💡 Ce moment est essentiel et permet de poser les bases de la relation thérapeutique, du cadre et de l’accompagnement.
          </p>
        </div>

        <div className="consultation-card">
          <div className="card-header">
            <h3>Séance de suivi</h3>
            <span className="duration">Durée : 50 minutes</span>
          </div>
          <p>
            Les séances de suivi constituent un espace où vous déposez vos difficultés et avancez à votre rythme.
          </p>
          <p>
            Au fil des rencontres, nous travaillons ensemble à mieux comprendre votre fonctionnement, à identifier 
            vos ressources et à développer des stratégies adaptées. Le suivi évolue en fonction de vos besoins et de vos objectifs.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Psychotherapie;